export default {
    'newsletter.title': 'Buďte vždy první',
    'newsletter.btn': 'Přihlásit se',
    'newsletter.placeholder': 'Váš e-mail',
    'newsletter.subtitle': 'Zůstaňte informováni a buďte první, kdo se dozví novinky!',
    'instagram.title': 'Sledujte nás',
    'contact.title': 'Potřebujete pomoc?',
    'contact.hours': 'Po - Pá: 9:00 - 19:00',
    'login.title': 'Přihlášení k účtu',
    'cart.orderRecap': 'Rekapitulace objednávky',
    'cart.empty': 'Váš košík je prázdný',
    'cart.back': 'Zpět do obchodu'
}
